import { get, set } from 'min-dash'
// import {
//   FeelTemplatingEntry,
//   isFeelEntryEdited,
//   TextFieldEntry,
//   isTextFieldEntryEdited,
// } from '@bpmn-io/properties-panel'

// import { useVariables, usePropertiesPanelService } from '@bpmn-io/form-js-editor'

import UrlEntryHTM from './htmComponents/UrlEntryHTM/UrlEntryHTM'
import { customSelectType } from '../custom-http-bound-connector/CustomSearchSelect'
import { documentScannerType } from '../custom-document-scanner/DocumentScanner'
import BlackAndWhiteHTM from './htmComponents/BlackAndWhiteHTM/BlackAndWhiteHTM'

export class CustomPropertiesProvider {
  constructor(propertiesPanel) {
    propertiesPanel.registerProvider(this, 500)
  }

  getGroups(field, editField) {
    console.log('CustomPropertiesProvider active for field:', field)

    return (groups) => {
      if (field.type === customSelectType) {
        const generalIdx = findGroupIdx(groups, 'general')

        groups.splice(generalIdx + 1, 0, {
          id: 'searchableSelect',
          label: 'Searchable Select',
          entries: SearchableSelectEntries(field, editField),
        })

        return groups
      } else if (field.type === documentScannerType) {
        const generalIdx = findGroupIdx(groups, 'general')

        groups.splice(generalIdx + 1, 0, {
          id: 'documentScanner',
          label: 'Document Scanner',
          entries: DocumentScannerEntries(field, editField),
        })

        return groups
      } else {
        return groups
      }
    }
  }
}

CustomPropertiesProvider.$inject = ['propertiesPanel']

function SearchableSelectEntries(field, editField) {
  // const onChange = (key) => {
  //   return (value) => {
  //     editField(field, [ key ], value);
  //   };
  // };

  // const getValue = (key) => {
  //   return () => {
  //     return get(field, [ key ]);
  //   };
  // };

  const onChange = (key) => {
    return (value) => {
      const range = get(field, ['searchableSelect'], {})

      editField(field, ['searchableSelect'], set(range, [key], value))
    }
  }

  const getValue = (key) => {
    return () => {
      return get(field, ['searchableSelect', key])
    }
  }

  // return [
  //   {
  //     id: 'searchableSelect-url',
  //     component: UrlEntryFEEL,
  //     getValue,
  //     field,
  //     isEdited: isFeelEntryEdited,
  //     onChange,
  //   },
  // ]
  return [
    {
      id: 'searchableSelect-url',
      component: UrlEntryHTM,
      getValue,
      field,
      isEdited: () => false,
      onChange,
    },
  ]
}

function DocumentScannerEntries(field, editField) {
  const onChange = (key) => {
    return (value) => {
      const range = get(field, ['documentScanner'], {})

      editField(field, ['documentScanner'], set(range, [key], value))
    }
  }

  const getValue = (key) => {
    return () => {
      return get(field, ['documentScanner', key])
    }
  }

  return [
    {
      id: 'documentScanner-blackAndWhite',
      component: BlackAndWhiteHTM,
      getValue,
      field,
      isEdited: () => false,
      onChange,
    },
  ]
}

// function UrlEntryFEEL(props) {
//   const { field, getValue, id, onChange } = props

//   const debounce = (fn) => fn

//   const variables = useVariables().map((name) => ({ name }))

//   return FeelTemplatingEntry({
//     debounce,
//     element: field,
//     getValue: getValue('url'),
//     id,
//     label: 'URL',
//     setValue: onChange('url'),
//     variables,
//   })
// }

// Helper function
function findGroupIdx(groups, id) {
  return groups.findIndex((group) => group.id === id)
}
